import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import colors from '../../assets/theme/colors';
import MedicationEditorSheet from '../Dashboard/shared/MedicationEditorSheet';
import TimelineProviderQuickAdd from './TimelineProviderQuickAdd';

const TimelineMedicationReviewSheet = ({ review, childName = '' }) => {
  if (!review?.sheetOpen) return null;

  return (
    <MedicationEditorSheet
      open
      onClose={review.close}
      onClearDraft={review.close}
      childName={childName}
      child={{ name: childName }}
      title={review.existingMedication
        ? `Update ${review.draft?.name || 'medication'}`
        : `Add ${review.draft?.name || 'medication'} to medications`}
      draft={review.draft || {}}
      providers={review.providers}
      isEditing={Boolean(review.existingMedication)}
      onDraftChange={review.updateDraft}
      onSaveDraft={review.save}
      saveStatus={(review.saving || review.providerSaving) ? 'saving' : 'idle'}
      saveError={review.error}
      topContent={<Box>{review.selectionRequired ? (
        <Box>
          <Typography sx={{ mb: 1, fontSize: '0.9rem', fontWeight: 800, color: '#1F2937' }}>
            Which medication does this note refer to?
          </Typography>
          <Box sx={{ display: 'grid', gap: 1 }}>
            {review.medicationOptions.map((medication) => (
              <Button
                key={medication.id}
                variant="outlined"
                onClick={() => review.selectMedication(medication.id)}
                sx={{ justifyContent: 'flex-start', textTransform: 'none', fontWeight: 700 }}
              >
                {medication.name}
              </Button>
            ))}
            <Button
              variant="text"
              onClick={review.startNewMedication}
              sx={{ justifyContent: 'flex-start', textTransform: 'none', fontWeight: 800 }}
            >
              + Add a new medication
            </Button>
          </Box>
        </Box>
      ) : review.draft ? (
        <Box sx={{ p: 1, borderRadius: 2, bgcolor: alpha(colors.brand.deep, 0.06) }}>
          {review.existingMedication ? (
            <Typography sx={{ fontSize: '0.82rem', color: '#4B5563' }}>
              Current: {review.currentLabel || 'Details not recorded'}
            </Typography>
          ) : null}
          <Typography sx={{ mt: review.existingMedication ? 0.35 : 0, fontSize: '0.82rem', fontWeight: 800, color: '#1F2937' }}>
            Proposed: {review.proposedLabel || 'Complete the missing details below'}
          </Typography>
        </Box>
      ) : null}
      <TimelineProviderQuickAdd review={review} />
      </Box>}
    />
  );
};

export default TimelineMedicationReviewSheet;
